/// <reference path="/js/lib/jquery/jquery-1.9.1.js"/>
/// <reference path="/js/lib/backbone.js"/>
/// <reference path="BreakdownSelectorView.js"/>
/// <reference path="BaseSelectorView.js"/>
/// <reference path="~/js/lib/jquery/jquery.multiselect.js"/>
/// <reference path="~/js/lib/lodash.js"/>

(function($, _) {
  var ns = window.nspace("ccc.viz.selectors");

  // NOTE MultipleBreakdownSelectorViewBase is a legacy version of BreakdownSelectorView
  // we changed BreakdownSelectorView and it broke MultipleBreakdownSelectorView
  ns.MultipleBreakdownSelectorView = ns.MultipleBreakdownSelectorViewBase.extend(
    {
      name: "Multiple Breakdown Selector",
      el: "#multiple-breakdown-selector",
      templateSelector: "#multiple-breakdown-selector-template",

      initialize: function(options) {
        // Call the base implementation
        ns.BreakdownSelectorView.__super__.initialize.call(this, options);

        $(window).on("resize", this.repositionMultiselect);
      },

      events: {
        change: "onChangeUpdateModel"
      },

      onChangeUpdateModel: function() {
        function capitalizeFirstLetter(string) {
          return string.charAt(0).toUpperCase() + string.slice(1);
        }

        // Indicator ID comes from the radio buttons
        var $checkedRadioButton = $("input:radio:checked", this.$el);
        var indId = $checkedRadioButton.val();

        // Characteristic ID comes from the checkbox
        var chId = $("input:radio:checked~select", this.$el).val();

        var lastIndId = this.model.attributes.indicatorId;
        var lastChId = this.model.attributes.characteristicId;
        if (indId !== lastIndId || chId !== lastChId) {
          // Tracks when a user clicks on a "Breakdown" radio button on the "Explore Data" page
          var selectedTab = capitalizeFirstLetter(
            window.location.pathname.split("/")[2]
          ); // e.g. 'Map', 'Table', 'Bar chart' tab
          var selectedBreakdown = $checkedRadioButton.siblings("label").text(); // distribution name

          var selectedCharacteristics = [];
          if (chId && chId.length) {
            for (var i = 0; i < chId.length; i++) {
              selectedCharacteristics.push(
                $("input:radio:checked~select", this.$el)
                  .children('[value="' + chId[i] + '"]')
                  .text()
              );
            }
          }
          if (!selectedCharacteristics.length) {
            if (
              $checkedRadioButton.siblings("button").hasClass("ui-state-active")
            ) {
              // Unchecked all characteristics; do nothing
            }
            else {
              // Clicked on the radio button itself, rather than the Uncheck All button; include all characteristics
						var radioSelector = "input:radio[value='" + indId + "']";
              if ($(radioSelector).length === 0) {
                // No match? Update the model to match the value of the first radio button
                radioSelector = "input:radio:first";
              }
              var allOptions = $(radioSelector + "~select option")
                .map(function() {
                  return this.value;
                })
                .get();

              var self = this;
              _.each(allOptions, function(id) {
                var indicatorId, name, modifiedName;

                name = _.filter(
                  self.model.selectorInfo.selectors[indId].characteristics,
                  function(characteristic) {
                    return +characteristic.id === +id;
                  }
                )[0].name;

                selectedCharacteristics.push(name);
              });
              selectedCharacteristics.sort();
            }
          }

          dataLayer.push({
            event: "Breakdown Radio Button Clicks",
            eventCategory: "Interactive Clicks",
            eventAction:
              selectedTab +
              "|" +
              selectedBreakdown +
              "|" +
              selectedCharacteristics,
            eventLabel: window.location.pathname
          });
        }

        var props = {};
        props.characteristicIds = chId || [];
        props[this.propertyName] = indId;

        // Other selectors are indicator-specific and may need to update other model properties
        // in response to the indicator changing. In order to accommodate that, emit a "before-change"
        // event and pass along the new properties, allowing any handlers to modify the set of new
        // properties as needed. This will prevent multiple change events from firing in response to the
        // indicator changing.
        this.model.trigger("before-change", props);

        // Update the model
        this.model.set(props);
      },

      /**
       * Updates the model with default selections, for cases where the user arrives
       * at the page with nothing preselected.
       */
      initializeModel: function() {
        var indId, radioSelector, chId, optionIds, allOptions, modelValue;

        // It's possible to arrive here with an indicator set, but a required characteristic is not.
        // Try to retain the indicator if it's already set.
        indId = this.model.get(this.propertyName);

        // Do we have a matching radio button?
        radioSelector = "input:radio[value='" + indId + "']";
        if ($(radioSelector).length === 0) {
          // No match? Update the model to match the value of the first radio button
          radioSelector = "input:radio:first";

          this.model.set(this.propertyName, $(radioSelector, this.$el).val(), {
            silent: true
          });
        }

        // Do we have a matching selection in the characteristics dropdown?
        chId = this.model.get("characteristicIds");
        optionIds = $(radioSelector + "~select option", this.$el).map(
          function() {
            return this.value;
          }
        );

        if (!chId || !_.intersection(optionIds, chId).length) {
          allOptions = $(radioSelector + "~select option")
            .map(function() {
              return this.value;
            })
            .get();
          modelValue = allOptions.length ? allOptions : ["a"];
          this.model.set("characteristicIds", modelValue, { silent: true });
        }
      },

      /**
       * Repositions the multiselect, as the plugin (unwisely) positions the dropdown out of the select
       * element's scope.
       */
      repositionMultiselect: function() {
        this.$(".characteristics")
          // Make sure multiselect is initialized.
          .multiselect(this.defaultMultiSelectOptions)
          .multiselect("position");
      },

      /**
       * Updates the DOM to match the selections specified on the model
       */
      updateDOM: function() {
        // Choose the radio button with the value specified in the model
        var radioSelector =
          "input:radio[value='" + this.model.get(this.propertyName) + "']";
        $(radioSelector).prop("checked", true);

        if (!this.model.get("characteristicIds")) {
          return;
        }

        // Select the corresponding characteristic from the dropdown, too
        $(radioSelector + "~select").val(this.model.get("characteristicIds"));
      },

      /**
       * Returns text summarizing the currently selected options for this selector.
       */
      getDataSummaryText: function() {
        var radioSelector, distro, $selectedOptions;

        // Don't include the selected value in the data summary if the control is hidden
        if (this.isHidden) {
          return null;
        }

        radioSelector =
          "input:radio[value='" + this.model.get(this.propertyName) + "']";
        distro = $(radioSelector, this.$el).data("name");
        // TODO: we're duplicated the summary text logic here, as this is handled by BaseSelectorView.defaultMultiselectOptions.selectedText, but it's necessary to implement our own method here because
        // 1) That callback is called *after* this function is called, and 2) there's multiselect markup there that's being used to generate the summary text, not the ordinary select markup.
        // Maybe there's a way around this somehow?
        $selectedOptions = $(
          radioSelector + "~select option:checked",
          this.$el
        );

        if ($selectedOptions.length > 1) {
          return distro + ": " + $selectedOptions.length + " selected";
        }

        if ($selectedOptions.length === 1) {
          return distro + ": " + $selectedOptions.text();
        }

        // Though there aren't any options checked, there are options available.
        if ($(radioSelector + "~select option", this.$el).length) {
          return distro + ": None selected";
        }

        return distro;
      },

      showHideCharacteristicSelector: function() {
        // Show ONLY the characteristics for the currently selected breakdown
        $(".characteristics ~ .ui-multiselect", this.el).hide();
        $("br", this.el).hide();

        var radioSelector =
          "input:radio[value='" + this.model.get(this.propertyName) + "']";
        $(
          radioSelector + " ~.ui-multiselect, " + radioSelector + " ~br",
          this.el
        ).show();
      },

      render: function(selectorInfo) {
        var $characteristics;

        // Call the base implementation
        ns.BreakdownSelectorView.__super__.render.call(this, selectorInfo);

        $characteristics = $(".characteristics", this.el).multiselect(
          this.defaultMultiSelectOptions
        );

        // Hide the characteristic dropdown if it's not configured to be shown
        if (this.hideCharacteristics) {
          $characteristics.hide();
          $("br", this.el).hide();
        }
        else {
          // Otherwise show only the characteristics for the current indicator
          this.showHideCharacteristicSelector();
        }

        // Don't bother rendering again
        this.isRendered = true;

        // Hide the selector if there is only a single indicator with no breakdown
        if (
          selectorInfo.indicators.length == 1 &&
          !selectorInfo.selectors[selectorInfo.indicators[0].id].characteristics
        ) {
          this.$el.hide();
          this.isHidden = true;
        }
      }
    }
  );
})(jQuery, _);
